<template>
    <div>
      <b-form-group
        label="Data da reprovação"
        label-for="input-disapprovalDate"
        label-cols-sm="5"
        label-cols-md="5"
        label-cols-lg="5"
      >
        <b-form-input
          id="input-disapprovalDate"
          v-model="formatedDatePendecieApproval"
          readonly
        />
      </b-form-group>
      <b-form-group
        label="Responsável pela reprovação"
        label-for="input-disapprovalUsername"
        label-cols-sm="5"
        label-cols-md="5"
        label-cols-lg="5"
      >
        <b-form-input
          id="input-disapprovalUsername"
          v-model="pendency.disapprovalUsername"
          readonly
        />
      </b-form-group>
      <b-form-group
        label="Descrição da reprovação"
        label-for="input-descriptionApproval"
        label-cols-sm="5"
        label-cols-md="5"
        label-cols-lg="5"
      >
        <b-form-textarea
          id="input-descriptionApproval"
          v-model="pendency.disapprovalDescription"
          readonly
        />
      </b-form-group>
      <b-row align-h="end">
        <b-col md="7">
          <b-row
            align-h="end"
            class="text-center"
            v-if="pendency.attachments != null && pendency.attachments.length > 0"
          >
            <b-col
              v-for="(attachment, i) in pendency.attachments"
              :key="i"
              md="6"
            >
            <!-- {{attachment}} -->
              <pendency-approved-data-attachment :attachment="attachment">
              </pendency-approved-data-attachment>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </template>
  
  
  <script>
  import PendencyApprovedDataAttachment from "@/components_rms/checklist/pendency/PendencyDisapprovedDataAttachment.vue";
  
  export default {
    components: {
      PendencyApprovedDataAttachment,
    },
    props: {
      pendency: Object,
    },
    data: function () {
      return {};
    },
    computed: {
      formatedDatePendecieApproval() {
        if (this.pendency) {
          if (this.pendency.disapprovalDate) {
            let date = new Date(this.pendency.disapprovalDate);
            return date.toLocaleString();
          }
        }
        return "";
      },
    },
    methods: {},
  };
  </script>